import React, {Component} from "react";
import {connect} from "react-redux";
/** Component */
import CommitmentForm from "../Component/Commitment/Commitment";
import {getFormValues} from "redux-form";
import {getSignPad, getSignType, isSignatureEmpty,} from "../../NTICore/component/Signature/selector";
import {saveAgreement, saveCommitment} from "../service";
import { AGREEMENT_PDF, COMMITMENT_PDF } from "../assets/js/constants";

class CommitmentContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showRequiredSignMessage: false,
      processingForm: false,
      apiMessage: ''
    }
  }

  /**
   * Catch all errors in this component
   * @param error
   * @param errorInfo
   */
  componentDidCatch(error, errorInfo) {
    console.log("Error: ", error, "ErrorInfo: ", errorInfo);
  }

  /**
   *
   * @param form
   */
  saveCommitment = async (form) => {
    const {onCommitmentSaved, isSignatureEmpty, signType, signPad, isPartner, agreement} = this.props;

    if (isSignatureEmpty) {
      this.setState({showRequiredSignMessage: true});
      return false;
    } else if (form !== null) {
      this.setState({requiredSignMessage: false});
      form.signatureName = signType === null ? '' : signType;
      form.signatureImageBase64 = signPad === null ? '' : signPad;
      this.setState({processingForm: true});

      if (isPartner === true) {
        // Save Commitment
        try {
          await saveCommitment(form);
          this.setState({processingForm: false});
          this.setState({apiMessage: "Commitment saved successfully!"});
          if (onCommitmentSaved instanceof Function) {
            onCommitmentSaved(form, true, COMMITMENT_PDF);
          }
        } catch (e) {
          this.setState({processingForm: false});
          if (e.code >= 500) {
            this.setState({apiMessage: "An unexpected error has occurred while saving data. Please try again, if the problem persists please contact our sales team."})
          } else {
            this.setState({apiMessage: e.message})
          }
        }
      } else if(agreement !== null) {
        try {
          /* Save Agreement with Commitment */

          // reset partner agreement inside commitment
          form.partnerAgreement = null;
          const agreementForm = {
            ...agreement, // Added Partner Agreement
            commitment: form // Added Commitment
          };
          // Added sign from commitment
          agreementForm.signatureImageBase64 = form.signatureImageBase64;
          agreementForm.signatureName = form.signatureName;
          // mondayItemId: this Contact's own Monday id (from the sign-up link) — lets
          // the backend link a brand-new Partner back to this Contact when one didn't
          // exist yet. partnerMondayId: the linked Partner's Monday id, when prefill
          // found one — bridges this lead's Monday identity (the item preview-tracking
          // has been using) onto the Commitment id the backend creates on signature;
          // without it the backend has no way to link the two and creates a second,
          // disconnected Monday item for this same lead. Null is fine here (no Partner
          // existed yet) — the backend falls back to creating one from scratch.
          agreementForm.mondayItemId = this.props.mondayItemId;
          agreementForm.partnerMondayId = this.props.partnerMondayId;

          await saveAgreement(agreementForm);
          this.setState({processingForm: false});
          this.setState({apiMessage: "Agreement saved successfully!"});
          if (onCommitmentSaved instanceof Function) {
            onCommitmentSaved(form, true, AGREEMENT_PDF);
          }
        } catch (e) {
          this.setState({processingForm: false});
          if (e.code >= 500) {
            this.setState({apiMessage: "An unexpected error has occurred. Please try again, if the problem persists please contact our sales team."})
          } else {
            this.setState({apiMessage: e.message})
          }
        }
      }
    }
  };

  render() {
    let disabledSubmit = true;
    if (
      this.props.formValues &&
      this.props.formValues.agree &&
      !this.props.isSignatureEmpty &&
      (this.props.signPad || this.props.signType)
    )
      disabledSubmit = false;

    return (
      <CommitmentForm
        showRequiredSignMessage={this.state.showRequiredSignMessage}
        apiMessage={this.state.apiMessage}
        submitForm={this.saveCommitment}
        disabledSubmit={disabledSubmit}
        processingForm={this.state.processingForm}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // Get form values
    formValues: getFormValues("commitmentForm")(state),

    // Get values from Signature Selector API
    signPad: getSignPad(state),
    signType: getSignType(state),
    isSignatureEmpty: isSignatureEmpty(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // Form Action
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommitmentContainer);



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Container/CommitmentContainer.js